import { isCapacitorPlatform } from "@src/appV2/lib";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { share } from "@src/appV2/NativeAdapters/share.adapter";

import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../../types";

interface ShareReferralLinkOptions {
  signUpReferralCodeLink: string;
  referralCode: string;
}
export async function shareReferralLink(options: ShareReferralLinkOptions) {
  const { signUpReferralCodeLink, referralCode } = options;
  const isCapacitorSupported = isCapacitorPlatform();
  const content = {
    title: "You should check out Clipboard!",
    text: "Hey there 👋 sign up to Clipboard so you can start posting and filling up shifts with workers like me!",
    url: signUpReferralCodeLink,
  };
  try {
    // The adapter handles platform-specific behavior internally
    const shareResult = await share(content);
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.REFERRAL_LINK_SHARED,
      component: WorkplaceReferralComponent.SHARE_REFERRAL_LINK_DIALOG,
      referralCode,
      link: signUpReferralCodeLink,
      isMobile: isCapacitorSupported,
      shareResult,
    });
  } catch (error) {
    // When user closes the native share dialog manually, it will throw an error
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.REFERRAL_LINK_SHARED,
      component: WorkplaceReferralComponent.SHARE_REFERRAL_LINK_DIALOG,
      referralCode,
      link: signUpReferralCodeLink,
      isMobile: isCapacitorSupported,
      error: String(error),
    });
  }
}
